import { render } from "./Matrix.vue?vue&type=template&id=b0544438&scoped=true"
import script from "./Matrix.vue?vue&type=script&lang=js"
export * from "./Matrix.vue?vue&type=script&lang=js"

import "./Matrix.vue?vue&type=style&index=0&id=b0544438&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0544438"]])

export default __exports__